import React, { Component } from "react";
import { Progress } from "react-sweet-progress";
import "react-sweet-progress/lib/style.css";
import { If } from "react-extras";
import { colors } from "../../../lib/design";
import "./progress_bar.scss";

class ProgressBar extends Component {
  render() {
    return (
      <div className="seedcast-progress-bar">
        <If condition={Boolean(this.props.title)}>
          <div className="seedcast-progress-bar__title">{this.props.title}</div>
        </If>
        <Progress
          percent={Math.ceil((this.props.current / this.props.total) * 100)}
          status={this.props.status}
          theme={{
            default: {
              color: colors.mediumBlue,
            },
            active: {
              color: colors.mediumBlue,
            },
          }}
        />
        <If condition={Boolean(this.props.subtitle)}>
          <div className="seedcast-progress-bar__subtitle">{this.props.subtitle}</div>
        </If>
      </div>
    );
  }
}

export default ProgressBar;
